import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage";
import UniInfoPage from "./modules/BaseInfo/UniInfo/UniInfoPage";
import { GroupBasePage } from "./modules/BaseInfo/groups/GroupBasePage";
import { TermBasePage } from "./modules/BaseInfo/terms/TermBasePage";
import PlacePage from "./modules/BaseInfo/places/PlacePage";
import UsersPage from "./modules/BaseInfo/user/UsersPage";
import CalendarBasePage from "./modules/BaseInfo/yearCalendar/CalendarBasePage";
import { ProvinceBasePage } from "./modules/BaseInfo/proviences/ProvinceBasePage";
import CategoryPage from "./modules/BaseInfo/category/CategoryPage";
import SeatPage from "./modules/BaseInfo/seat/SeatPage";
import AuditPeriodPage from "./modules/BaseInfo/auditPeriod/AuditPeriodPage";
import { FormBasePage } from "./modules/BaseInfo/forms/FormBasePage";
import AuditQuestionPage from "./modules/BaseInfo/auditList/saveAudit/AuditQuestionPage";
import BuildingPage from "./modules/BaseInfo/building/BuildingPage";
import { AuditResultBasePage } from "./modules/BaseInfo/auditFormResult/AuditResultBasePage";
import RolePage from "./modules/BaseInfo/permissions/RolePage";
import UserProfilePage from "./modules/UserProfile/UserProfilePage";
import { AuditReportBasePage } from "./modules/BaseInfo/auditFormReport/AuditReportBasePage";
import { BuildingReportBasePage } from "./modules/BaseInfo/buildingReport/BuildingReportBasePage";
import FloorReportPage from "./modules/BaseInfo/floorReport/FloorReportPage";
import { ManagementAuditReportBasePage } from "./modules/BaseInfo/auditFormReportManagment/ManagementAuditReportBasePage";
import ManagementPlaceAuditFormReportPage from "./modules/BaseInfo/auditFormReportManagment/ManagementPlaceAuditFormReportPage";
import PlaceAuditFormReportPage from "./modules/BaseInfo/auditFormReport/PlaceAuditFormReportPage";
import PlaceBuildingReportPage from "./modules/BaseInfo/buildingReport/PlaceBuildingReportPage";
import ReportTestPage from "./modules/BaseInfo/UniInfo/ReportTestPage";
import CountryBuildingReportPage from "./modules/BaseInfo/buildingReport/CountryBuildingReportPage";
import ProvienceBuildingReportPage from "./modules/BaseInfo/buildingReport/ProvienceBuildingReportPage";
import CountryAuditFormReportPage from "./modules/BaseInfo/auditFormReport/CountryAuditFormReportPage";
import ProvienceAuditFormReportPage from "./modules/BaseInfo/auditFormReport/ProvienceAuditFormReportPage";
import ManagementCountryAuditFormReportPage from "./modules/BaseInfo/auditFormReportManagment/ManagementCountryAuditFormReportPage";
import ManagementProvienceAuditFormReportPage from "./modules/BaseInfo/auditFormReportManagment/ManagementProvienceAuditFormReportPage";
// import { ShiftBasePage } from "./modules/Attendence/shifts/ShiftBasePage";
// import DailyMissionPage from "./modules/Attendence/missions/DailyMissionPage";

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {<Redirect exact from="/" to="/dashboard" />}
        {<Redirect exact from="/attendance" to="/attendance/dashboard" />}
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/terms" component={TermBasePage} />
        <ContentRoute path="/uni" component={UniInfoPage} />
        {/* <ContentRoute path="/building" component={BuildingBasePage} /> */}
        <ContentRoute path="/building" component={BuildingPage} />
        {/* <ContentRoute path="/floors" component={FloorPage} /> */}
        <ContentRoute path="/provinces" component={ProvinceBasePage} />
        <ContentRoute path="/groups" component={GroupBasePage} />
        <ContentRoute path="/audit" component={AuditPeriodPage} />
        <ContentRoute path="/category" component={CategoryPage} />
        <ContentRoute path="/managePlaces" component={PlacePage} />
        <ContentRoute path="/calendar" component={CalendarBasePage} />
        <ContentRoute path="/permissions" component={RolePage} />
        <ContentRoute path="/user" component={UsersPage} />
        <ContentRoute path="/seats" component={SeatPage} />
        <ContentRoute path="/form" component={FormBasePage} />
        {/* <ContentRoute path="/placeFormList" component={AuditFormResultPage} /> */}
        <ContentRoute path="/resultForms" component={AuditResultBasePage} />

        {/* <ContentRoute path="/reports" component={AuditReportBasePage} /> */}
        <ContentRoute path="/reportsCountry" component={CountryAuditFormReportPage} />
        <ContentRoute path="/reportsProvience" component={ProvienceAuditFormReportPage} />
        <ContentRoute path="/reportPlaces" component={PlaceAuditFormReportPage} />

        {/* <ContentRoute path="/manageReport" component={ManagementAuditReportBasePage} /> */}
        <ContentRoute path="/manageReportCountry" component={ManagementCountryAuditFormReportPage} />
        <ContentRoute path="/manageReportProvience" component={ManagementProvienceAuditFormReportPage} />
        <ContentRoute path="/placeManageReport" component={ManagementPlaceAuditFormReportPage} />


        {/* <ContentRoute path="/blockReport" component={BuildingReportBasePage} /> */}
        <ContentRoute path="/blockReportCountry" component={CountryBuildingReportPage} />
        <ContentRoute path="/blockReportProvience" component={ProvienceBuildingReportPage} />
        <ContentRoute path="/blocksReportPlaces" component={PlaceBuildingReportPage} />


        <ContentRoute path="/floorReport" component={FloorReportPage} />
        {/* <ContentRoute path="/formList/buildings" component={AuditResultBasePage} /> */}
        {/* <ContentRoute path="/formList/placeFormList" component={PlaceAuditFormResultPage} /> */}

        <ContentRoute path="/auditQuestions" component={AuditQuestionPage} />
        <ContentRoute path="/testReport" component={ReportTestPage} />
        {/* <ContentRoute path="/user-profile" component={UserProfilePage} /> */}

        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
